// import S3FileUpload from 'react-s3';
import { aws, env } from '../Env';
import { rqx } from '../request/API';
// const config = {
//     bucketName: aws('bucket_name'),
//     dirName: `${env()==='local'?'dev':env()}`,
//     region: aws('region'),
//     accessKeyId: aws('access_key'),
//     secretAccessKey: aws('secret_key'),
// }

// export const S3 = (file) => {
//     const d = new Date()
//     let split_name = file[0].name.split('.')
//     let ext = split_name[split_name.length - 1]
//     let blob = file[0].slice(0, file[0].size, file[0].type);
//     let newFile = new File([blob], `${d.getTime()}.${ext}`, {
//         type: file[0].type
//     });

//     return new Promise(resolve => {
//         S3FileUpload.uploadFile(newFile, config).then(data => {
//             return resolve(data)
//         }).catch(err => {
//             return resolve(err)
//         })
//     })
// }

export const uploadToS3Presigned = async (file, params) => {
    const { requestRef, feature_ref, tool_id, privacy = 'private' } = params
    const body = {
    rqxRef: requestRef,
        file_name: file[0].name,
        file_type: file[0].type,
        size: file[0].size,
        feature_ref,
        tool_id,
        env: env(),
        privacy
    }
    const rqxPreSigned = await rqx.post(`<<s3>>/${env()}/glbl/transmit/uploadRqx`,body)
    const { uploadUrl } = rqxPreSigned
    const uploadResponse = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
            'Content-Type': file[0].type
        },
        body: file[0]
    })
    return rqxPreSigned
}